export default "/images/f11ecd1ea4b7b78d9704f19db815070f.avif";